import React, { useState } from "react"
import { Label, Textarea, Box } from "theme-ui"

// hook borrowed from https://usehooks.com/useLocalStorage/
function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key)
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      // If error also return initialValue
      console.log(error)
      return initialValue
    }
  })

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      // Save state
      setStoredValue(valueToStore)
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error)
    }
  }

  return [storedValue, setValue]
}

const ExerciseTextArea = ({ name, caption, short, long }) => {
  const [text, setText] = useLocalStorage(`exerciseState:${name}`)

  return (
    <Box sx={{ mt: 3, mb: 5 }}>
      <Label htmlFor={name}>{caption || "Your answer"}</Label>
      <Textarea
        id={name}
        name={name}
        value={text}
        onChange={(event) => setText(event.target.value)}
        rows={short ? 1 : long ? 10 : 5}
      />
    </Box>
  )
}

export default ExerciseTextArea
